import {SETTINGS_PAGE_PATH} from '~shared/constants';

import {HOME_PAGE_SLUG} from '~ui/constants';

import {removeTrailingSlash} from './remove-trailing-slash';
import {trimSlashes} from './trim-slashes';

function parseHandler(rawPath: string) {
    const indexOfHandler = rawPath.indexOf('/.');

    if (indexOfHandler > -1) {
        return {
            path: rawPath.substring(0, indexOfHandler + 1),
            handler: rawPath.substring(indexOfHandler + 1),
        };
    }

    return {
        path: rawPath,
        handler: '',
    };
}

function parsePath(rawPath: string) {
    const {path, handler} = parseHandler(rawPath);
    const isRoot = path === '/';
    const isSettings = removeTrailingSlash(path) === SETTINGS_PAGE_PATH;

    return {
        normalizedPath: isRoot || isSettings ? HOME_PAGE_SLUG : trimSlashes(path),
        pathname: path,
        handler,
        isRoot,
        isSettings,
    };
}

export {parsePath};
